<template>
    <modal
        :title="$t(title)"
        :id="id"
        :actionButtons="false"
        size="full"
        :closeButton="true"
        @shown="shown()"
        @hidden="hidden()"
    >
        <template slot="modal-header">
            <span></span>
        </template>
        <div class="document-print-modal" v-if="customer && company">
            <div class="card-body row" id="printContent" v-if="document">
                <div class="col-12">
                    <company-print-header></company-print-header>
                    <hr/>
                </div>
                <div class="document-print-modal-content mt-5" v-html="content"></div>
            </div>
        </div>
        <template slot="modal-footer">
            <div class="row d-none">
                <div class="col-12 col-lg-10 col-xl-8 p-5 text-muted border-top">Document generated by MyClient.uz</div>
            </div>
            <div class="card-footer invoiceFooter" style="display:block">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-white mr-2" @click="print()">
                            <i class="fe fe-printer"></i>
                            {{ $t('Print') }}
                        </button>
                        <button type="button" @click="close" class="btn btn-white">
                            {{ $t('Close') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import {mapActions, mapGetters} from 'vuex';
import {modalMixins} from '@/mixins/modal.js';
import CompanyPrintHeader from "@/components/Company/CompanyPrintHeader.vue";
import Dispatch from "@/Pages/Company/Dispatch.vue";

function replaceStr(str, find, replace) {
    for (let i = 0; i < find.length; i++) {
        str = str.replace(new RegExp(find[i], 'gi'), replace[i]);
    }
    return str;
}

export default {
    name: 'print-options',
    props: ['id', 'saveAction', 'data', 'customerId'],
    mixins: [modalMixins],
    components: {
        Dispatch,
        Modal,
        CompanyPrintHeader,
    },
    data() {
        return {
            title: 'Document',
        }
    },
    computed: {
        ...mapGetters('my-team', {getDoctorFromStore: 'get'}),
        ...mapGetters('customers', {
            getCustomerFromStore: 'get'
        }),
        ...mapGetters('documents', {
            getDocumentFromStore: 'get',
        }),
        ...mapGetters('my-company', {
            getCompanyFromStore: 'get'
        }),
        document() {
            return this.getDocumentFromStore(this.data.documentId);
        },
        company() {
            return this.getCompanyFromStore("mine");
        },

        content() {
            // return this.document.replace()
            if (!this.document.content) return;
            let doctor = this.getDoctorFromStore(this.customer.userId[0]) || {};
            this.$moment.locale(this.document.language || 'ru');
            let replace = {
                what: [
                    '#COMPANY_NAME',
                    '#USER.FIRST_NAME',
                    '#USER.LAST_NAME',
                    '#USER.MIDDLE_NAME',
                    "#USER.GENDER",
                    "#USER.AGE",
                    "#USER.ADDRESS",
                    "#USER.BIRTH_DATE",
                    "#USER.PASSPORT_NUMBER",
                    "#USER.PASSPORT_GIVEN",
                    "#DOCTOR.FIRST_NAME",
                    "#DOCTOR.LAST_NAME",
                    "<p style=\"text-align: justify;\"><!-- pagebreak --></p>",
                    "#CURRENT_DATE",
                ],
                with: [
                    this.company.name,
                    this.customer.first_name,
                    this.customer.last_name,
                    this.customer.middle_name,
                    this.$t(this.customer.gender),
                    this.$moment().diff(this.customer.birth_date, 'years'),
                    this.customer.address || '',
                    this.$moment(this.customer.birth_date).local().format('Do MMMM YYYY'),
                    this.customer.passportNumber || '',
                    this.customer.passportGiven || '',
                    doctor.firstName || '',
                    doctor.lastName || '',
                    "<div style='display: block; page-break-before: always;'></div>",
                    this.$moment().local().format('D.MM.YYYY')
                ]
            };
            return replaceStr(this.document.content, replace.what, replace.with);
        },
        customer() {
            return this.getCustomerFromStore(this.customerId);
        },

    },
    mounted() {
    },

    methods: {
        ...mapActions('documents', {getById: 'get'}),

        shown() {
            this.getById(this.data.documentId);
        },
        hidden() {
            var $printSection = document.getElementById("printSection");
            if ($printSection) {
                $printSection.remove();
            }
        },
        print() {
            var domClone = document.getElementById("printContent").cloneNode(true);

            var $printSection = document.getElementById("printSection");
            if (!$printSection) {
                var $printSection = document.createElement("div");
                $printSection.id = "printSection";
                document.body.appendChild($printSection);
            }
            $printSection.innerHTML = "";
            $printSection.appendChild(domClone);
            window.print();
        },
        close() {
            this.$root.$emit('bv::hide::modal', this.id);
        },


    },
}
</script>
<style lang="scss">

.document-print-modal {
    height: calc(var(--calculated-vh, 1vh) * 100 - 125px);
    #printContent {
        height: 100%!important;
    }
    overflow-y: auto;
    & > * {
        word-break: break-word;
    }
    p {
        font-size: 16px!important;
        line-height: 24px!important;
    }
    &-content {
        max-height: 100%!important;
        max-width: 100%!important;
    }
}

@media print {
    .document-print-modal-content p {
        font-size: 18px!important;
        line-height: 24px!important;
    }
}

</style>

